import React, { useEffect, useState } from "react";
import Logo from "../images/logo_white.png";
import "./Header.css";
import { useAppContext } from "../services/AppService";
import { SearchIcon } from "./icons/SearchIcon";
import { searchTerms } from "../lib/search";
import { BasicCard } from "./ui/card";
import { CancelIcon } from "./icons/CancelIcon";
import { Category } from "../data/RowData";

export const Header: React.FC = () => {
    const [iconColor, setIconColor] = useState<string | null>(null);
    const { state, setState, resetAll } = useAppContext();
    const [showDropwdown, setShowDropdown] = useState(false);
    const [showItems, setShowItems] = useState<string[]>([]);
    const activeIconColor = "#F26859";

    useEffect(() => {
        if (state.category !== Category.all) {
            setIconColor(activeIconColor);
        }
        if (!!state.search) {
            setIconColor(activeIconColor);
        }
    }, [state.category, state.search]);

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState("search", event.target.value);
        if (event.target.value !== "") {
            let results: string[] = [];
            const pattern = new RegExp(event.target.value, "gi");
            searchTerms.forEach((i) => {
                if (i.match(pattern)) {
                    setShowDropdown(true);
                    results.push(i);
                }
            });
            setShowItems(results);
        } else {
            setShowDropdown(false);
        }
    };

    const onReset = () => {
        resetAll();
        setShowDropdown(false);
        setShowItems([]);
    };

    return (
        <div
            onClick={() => setState("hamburgerMenuIsOpen", false)}
            className="header"
        >
            <div className="logo-container">
                <img
                    onClick={onReset}
                    className="logo"
                    src={Logo}
                    alt="Ergotron logo"
                    height={44}
                />
            </div>
            <div className="search">
                <span className="search-icon">
                    <SearchIcon color={iconColor} />
                </span>
                <input
                    onFocus={() => setIconColor("#F26859")}
                    onBlur={() => setIconColor("")}
                    onChange={onChange}
                    type="text"
                    placeholder="Search..."
                    value={state.search}
                />
                <span className="close-icon" onClick={onReset}>
                    <CancelIcon color={iconColor} />
                </span>
                {showDropwdown && (
                    <div className="card-menu">
                        {showItems.map((i, k) => (
                            <BasicCard
                                onClick={() => {
                                    setState("search", i);
                                    setShowDropdown(false);
                                    setShowItems([]);
                                }}
                                key={k}
                            >
                                {i}
                            </BasicCard>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
